/** @jsxImportSource @emotion/react */
import { memo } from "react";

import {
  mtgGroup,
  mtgCaption,
  mtgCaptionList,
} from "assets/css/stylesCss";

import LabelWithOptionIcon from "components/ui/label/LabelWithOptionIcon";
import InputText from "components/ui/input/InputText";

import { formatTelNumber } from "utilities/formater";

/**
 * 固定電話番号
 * @param {Boolean} required true : 必須
 *                           false: 任意
 * @param {String} maxLength 最大文字数
 * @param {String} txtCaption キャプション 注釈
 */
const TelNo = memo(({ required, maxLength, txtCaption }) => {

  return (
    <div css={mtgGroup}>
      {/** ラベル */}
      {/** MEMO：携帯電話または固定電話片方が必須のため、任意項目だが任意ラベルは表示しない */}
      <LabelWithOptionIcon required={true}>
        固定電話番号
      </LabelWithOptionIcon>
      <InputText
        name="telNo"
        placeholder="0312345678"
        inputMode="numeric"
        maxLength={maxLength}
        pairNumber="phoneNo"
        rules={{
          pattern: {
            value: /^0(\d-\d{4}|\d{2}-\d{3}|\d{3}-\d{2}|\d{4}[-]?\d)[-]?\d{4}$/,
            message: "固定電話番号の形式が正しくありません。",
          },
        }}
        telNoValid={{
          formatTelNumber,
          message: "固定電話番号の形式が正しくありません。",
        }}
        isTelNo={true}
        required={required}
      ></InputText>
      <ul css={mtgCaptionList}>
        {txtCaption.map((item, index) => (
          <li key={index}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
});

export default TelNo;
